export default "__VITE_ASSET__haiYPN71__"